import VueRouter from 'vue-router'
import Vue from 'vue'

import Home from '../../src/views/Home/index.vue'
import Profiles from '../views/Profiles/index.vue'
import Leader from '../views/Leader/index.vue'
import Nav from '../views/Nav/index.vue'
import Institution from '../views/Institution/index.vue'
import PartyActive from '../views/Party/Active/index.vue'
import PartySystem from '../views/Party/System/index.vue'

import PartyDetils from '../views/Party/Detils/index.vue'
import EduDetils from '../views/Educational/Detils/index.vue'
import StuDetils from '../views/Student/Detils/index.vue'

import Mind from '../views/Party/nav/Mind/index.vue'
import Notice from '../views/Party/nav/Notice/index.vue'
import Regime from '../views/Party/nav/Regime/index.vue'
import Theory from '../views/Party/nav/Theory/index.vue'
import Life from '../views/orient/life/index.vue'
import Style from '../views/orient/style/index.vue'
import Talents from '../views/Talents/index.vue'
import TalentsDeatil from '../views/Talents/detail/detail.vue'
import Educational from '../views/Educational/index.vue'
import Student from '../views/Student/home.vue'
import Enrollment from '../views/Enrollment/index.vue'
import CopyRight from '../views/copyright/copyright.vue'
// 新建
import Search from '../views/search/search.vue'
import TeaDept from '../views/TeaDept/TeaDept.vue' // 机构设置-教学部门
import FunDept from '../views/FunDept/FunDept.vue' // 机构设置-职能部门
import Libary from '../views/Libary/Libary.vue' // 快捷入口-图书馆
import Edu from '../views/edu/edu.vue' // 快捷入口-学生处
import More from '../views/common/more/more.vue' // 首页-学校新闻-查看更多
import Medicine from '../views/connected/medicine/medicine.vue' // 相关链接-医学院
import Basic from '../views/connected/basic/basic.vue' // 相关链接-马克思主义学院
import Humanity from '../views/connected/humanity/humanity.vue'// 相关链接-人文学院
import Business from '../views/business/business.vue'// 相关链接-创新创业
import Economic from '../views/connected/economic/economic.vue'// 相关链接-经济管理学院
import Cultural from '../views/connected/cultural/cultural.vue'// 相关链接-文物与艺术学院
import Ai from '../views/connected/ai/ai.vue' // 相关链接-人工智能学院

import News from '../views/news/news.vue'// 首页文章列表跳转页面
import Detail from '../views/common/detail/detail.vue' // 首页通知公告跳转
import Convention from '../views/convention/convention.vue' // 首页专栏跳转-党建专栏
import Education from '../views/thematic/education/education.vue' // 首页专栏跳转-党建专栏-底部图片第一个
import SectionMore from '../views/common/section/more/more.vue' // 首页专栏跳转-党建专栏第二个
import SectionDetail from '../views/common/section/detail/detail.vue'
import BasicDetail from '../views/basic/detail/detail.vue' // 首页专栏跳转-党建专栏第二个-里面列表跳转链接
import Vr from '../views/vr/vr.vue'
import Relics from '../views/cultural/relics/relics.vue'
import Media from '../views/digital/media/media.vue' // 机构设置-教学部门-数字媒体学院
import searchDetail from '../views/search/detail/detail.vue'
import Personnel from '../views/personnel/personnel.vue'
import BursarOffice from '../views/bursar/office.vue'
import Dept from '../views/dept/dept.vue'
import Joinus from '../views/joinus/joinus.vue'
import partyCommonOffice from '../views/Party/common/office/detail.vue'
import employmentCenter from '../views/employment/center.vue'
import bannerDetail from '../views/bannerDetail/bannerDetail.vue'
// 机构设置-职能部门
import CommiteeOffice from '../views/Party/commitee/office.vue'
import CommiteePropaganda from '../views/Party/commitee/propaganda.vue'
import CommiteeLabor from '../views/Party/commitee/labor.vue'
import Profile from '../views/profile/profile.vue'
import RectoorOffice from '../views/rector/office.vue'
import TuanWei from '../views/tuanwei/tuanwei.vue'
import SecurityCenter from '../views/security/center.vue'
import Information from '../views/information/information.vue'
import TeacherDev from '../views/teacher/dev.vue'
import Teaching from '../views/teaching/teaching.vue'
import TeachingEval from '../views/teaching/eval.vue'
import ContinueEducation from '../views/continue/education.vue'
import Science from '../views/science/science.vue'
import humanityOrganization from '../views/humanity/organization.vue'
import basicOrganization from '../views/basic/organization/organization.vue'
import prActice from '../views/practice/practice.vue'

Vue.use(VueRouter)

let router = new VueRouter({
  routes: [
    // {
    //   path: '',
    //   redirect: '/home'
    // },
    {
      path: '',
      component: Home
    },
    {
      path: '/profile/:tabBarId',
      component: Profiles
    },
    {
      path: '/profile/:id/:val',
      component: Profiles
    },
    {
      path: '/profile/:id/:val1/:tabBarId',
      component: Profiles
    },
    {
      path: '/leader',
      component: Leader
    },
    {
      path: '/nav',
      component: Nav
    },
    {
      path: '/organization',
      component: Institution
    },
    {
      path: '/partyActive',
      component: PartyActive
    },
    {
      path: '/partySystem',
      component: PartySystem
    },
    {
      path: '/partyDetils',
      component: PartyDetils
    },
    {
      path: '/eduDetils',
      component: EduDetils
    },
    {
      path: '/stuDetils',
      component: StuDetils
    },
    {
      path: '/mind',
      component: Mind
    },
    {
      path: '/notice',
      component: Notice
    },
    {
      path: '/regime',
      component: Regime
    },
    {
      path: '/theory',
      component: Theory
    },
    {
      path: '/employment/center/:tabBarId',
      component: employmentCenter
    },
    {
      path: '/life',
      component: Life
    },
    {
      path:'/bannerDetail/:id',
      component:bannerDetail
    },

    {
      path: '/campus/more/:tabBarId',
      component: Style
    },
    {
      path: '/talents/:id/:tabBarId',
      component: Talents,
    },
    {
      path: '/talent/detail/:id',
      component: TalentsDeatil,
    },
    {
      path: '/educational',
      component: Educational
    },
    {
      path: '/practice/:tabBarId',
      component: prActice
    },
    {
      path: '/party/common/office/:tabBarId',
      component: Student
    },
    {
      path: '/enrollment/office/:tabBarId',
      component: Enrollment
    },
    // 新建
    {
      path: '/humanity/organization/:tabBarId',
      component: humanityOrganization
    },
    {
      path: '/basic/organization/:tabBarId',
      component: basicOrganization
    },
    {
      path: '/search/:search',
      component: Search
    },
    {
      path: '/teadept',
      component: TeaDept
    },
    {
      path: '/fundept',
      component: FunDept
    },
    {
      path: '/libary',
      component: Libary
    },
    {
      path: '/edu/:tabBarId',
      component: Edu
    },
    {
      path: '/common/more/:tabBarId',
      component: More,
      meta: { keepAlive: true }
    },
    {
      path: '/common/detail/:tabBarId/:id',
      component: Detail
    },
    {
      path: '/common/section/more/:parentId/:tabBarId',
      component: SectionMore,
      meta: { keepAlive: true }
    },
    {
      path: '/party/common/office/detail/:parentId/:id',
      component: partyCommonOffice
    },
    {
      path: '/common/section/detail/:parentId/:tabBarId/:id',
      component: SectionDetail
    },
    {
      path: '/medicine/:tabBarId',
      component: Medicine
    },
    {
      path: '/basic/:tabBarId',
      component: Basic
    },
    {
      path: '/humanity/:tabBarId',
      component: Humanity
    },
    {
      path:'/business/:tabBarId',
      component:Business
    },
    {
      path: '/economic/:tabBarId',
      component: Economic
    },
    {
      path: '/cultural',
      component: Cultural
    },
    {
      path: '/ai/:tabBarId',
      component: Ai
    },
    {
      path: '/news/:id',
      component: News
    },
    {
      path: '/convention',
      component: Convention
    },
    {
      path: '/thematic/education',
      component: Education
    },
    {
      path: '/basic/detail/:id',
      component: BasicDetail
    },
    {
      path: '/basic/detail/:parentId/:tabBarId/:id',
      component: BasicDetail
    },
    {
      path: '/vr',
      component: Vr
    },
    {
      path: '/cultural/relics/:tabBarId',
      component: Relics
    },
    {
      path: '/digital/media/:tabBarId',
      component: Media
    },
    {
      path: '/bursar/office/:tabBarId',
      component: BursarOffice
    },
    {
      path: '/dept/:tabBarId',
      component: Dept
    },
    {
      path: '/joinus/:useless',
      component: Joinus
    },
    {
      path: '/copyright',
      component: CopyRight
    },
    // 职能部门
    {
      path: '/party/committee/office/:tabBarId',
      component: CommiteeOffice
    },
    {
      path: '/party/committee/propaganda/:tabBarId',
      component: CommiteePropaganda
    },
    {
      path: '/party/committee/labor/:tabBarId',
      component: CommiteeLabor
    },
    {
      path: '/profileV/:id',
      component: Profile
    },
    {
      path: '/rector/office/:tabBarId',
      component: RectoorOffice
    },
    {
      path: '/searchs/detail/:parentId/:tabBarId/:id',
      component: searchDetail
    },
    {
      path: '/personnel/:tabBarId',
      component: Personnel
    },
    {
      path: '/tuanwei/:tabBarId',
      component: TuanWei
    },
    {
      path: '/security/center/:tabBarId',
      component: SecurityCenter
    },
    {
      path: '/information/:tabBarId',
      component: Information
    },
    {
      path: '/teacher/dev/:tabBarId',
      component: TeacherDev
    },
    {
      path: '/teaching/:tabBarId',
      component: Teaching
    },
    {
      path: '/continue/education/:tabBarId',
      component: ContinueEducation
    },
    {
      path: '/teaching/eval/:tabBarId',
      component: TeachingEval
    },
    {
      path: '/science/:tabBarId',
      component: Science
    }
  ],
  mode: 'history'

})
// router.beforeEach((to, from, next) => {
//   // 检查路由路径是否相等
//   if (to.path === from.path) {
//     // 如果路径相等，检查是否存在查询参数
//     if (Object.keys(to.query).length === 0) {
//       // 路径相等且不存在查询参数，阻止导航
//       next(false)
//     } else {
//       // 路径相等但存在查询参数，放行
//       next()
//     }
//   } else {
//     // 如果路径不相等，直接放行
//     next()
//   }
// })
// 新
router.beforeEach((to, from, next) => {
  // 检查路由路径是否相等
  if (to.path === from.path) {
    // 路径相等，不阻止导航，允许路由更新
    next()
  } else {
    // 如果路径不相等，直接放行
    next()
  }
})

// // 经验证，这个路由守卫没什么用，因为vue-router在跳转的路径相同的时候，在执行这个路由守卫之前就拦截了
// router.beforeEach((to, from, next) => {
//   // 检查路由路径是否相等
//   if (to.path === from.path) {
//     // 如果路径相等，检查是否存在查询参数
//     if (Object.keys(to.query).length > 0) {
//       // console.log('路由相等且存在查询参数，放行')
//       next() // 路径相等且存在查询参数，放行
//     } else {
//       // console.log('路由相等但不存在查询参数，阻止导航')
//       next(false) // 路径相等但不存在查询参数，阻止导航
//     }
//   } else {
//     // 如果路径不相等，直接放行
//     // console.log('路由不相等，放行')
//     next()
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js